import { useState } from "react";
import { Typography } from "@mui/material";
import BasicInfoSection from "../../clinic/components/profile/BasicInfoSection";
import ContactInfoSection from "../../clinic/components/profile/ContactInfoSection";
import AddressInfoSection from "../../clinic/components/profile/AddressInfoSection";
import { ToastContainer } from "react-toastify";

function Profile() { 
  const [collapsedSections, setCollapsedSections] = useState({
    basicInfo: true,
    contactInfo: true,
    addressInfo: true,
  });

  const toggleSection = (section) => {
    setCollapsedSections((prev) => ({ ...prev, [section]: !prev[section] }));
  };

  return (
    <div className="bg-gradient-to-b from-[#e8f0fb] from-[2%] via-white via-[50%]   to-[#fff] to-[48%]  min-h-[calc(100vh-72px)] w-full p-4 pt-10 pb-20">
      <Typography variant="h5" fontWeight="bold" color="#2C3E50">
        Profile
      </Typography>
      <ToastContainer/>
      <div className=" bg-white  drop-shadow-md rounded-md mt-3">
        <BasicInfoSection
          collapsed={collapsedSections.basicInfo}
          toggleSection={toggleSection}
          callType={'patient'}
        />
        {/* Contact Information Section */}
        <ContactInfoSection
          collapsed={collapsedSections.contactInfo}
          toggleSection={toggleSection}  
          callType={'patient'}    
        />

        {/* Address Information Section */}
        <AddressInfoSection
          collapsed={collapsedSections.addressInfo}
          toggleSection={toggleSection}
          callType={'patient'}  
        />
      </div>
    </div>
  );
}

export default Profile;
